import { UseFormReturnType } from "@mantine/form";
import { Group, NumberInput } from "@mantine/core";
import type { Quiz } from "quiz/types/quiz.model";

const fields = [
  ["question", "Questions"],
  ["choices", "Choices"],
  ["solution", "Response"],
  ["winner", "Name of winner"],
] as [keyof Quiz["durations"], string][];

export function QuizDurationsFormInput({
  form,
}: {
  form: UseFormReturnType<Omit<Quiz, "id">>;
}) {
  return (
    <Group>
      {fields.map(([name, label]) => (
        <NumberInput
          key={name}
          required
          sx={{ flex: "1 1 0" }}
          type={"number"}
          rightSectionWidth={100}
          rightSection={<span>secondes</span>}
          label={label}
          {...form.getInputProps(`durations.${name}`)}
        />
      ))}
    </Group>
  );
}
